// extracted by mini-css-extract-plugin
export default {"tabList":"src-TabList-module__tabList--ANhf9","noPadding":"src-TabList-module__noPadding--E9uWh"};